// Simple Babylist button tracking for Fathom
document.addEventListener('DOMContentLoaded', function() {
  function setupBabylistTracking() {
    const babylistButton = document.getElementById('babylist-button');
    if (babylistButton) {
      babylistButton.addEventListener('click', function(event) {
        const productTitle = this.getAttribute('data-product-title');
        // Track with Fathom
        if (typeof fathom !== 'undefined') {
          fathom.trackEvent(`Babylist Button Clicked: ${productTitle}`);
        }
      });
    }
  }

  setupBabylistTracking();
});
